/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Out_Action_Create_Scenting_PnkInputs */

const vi_sl_out_action_create_scenting_pnk = /** @type {(inputs: Sl_Out_Action_Create_Scenting_PnkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu nhập kho lấy hương`)
};

/**

* @param {Sl_Out_Action_Create_Scenting_PnkInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_out_action_create_scenting_pnk = /** @type {((inputs?: Sl_Out_Action_Create_Scenting_PnkInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Out_Action_Create_Scenting_PnkInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_out_action_create_scenting_pnk(inputs)
});